import { useDispatch, useSelector } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import '../css/payment.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';
import bank from '../bankList'

import { CountAmount, CountAmountLeft, CountSelect, DownloadBtn, TotalAmount } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import { SquareX, SquareCheck, X } from 'lucide-react';

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn } from '../component/search/search';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import dayjs from 'dayjs';

import { changeNum, convertDateFormat } from '../common/function';

function SugiManage() {
    let dispatch = useDispatch();
    let navigate = useNavigate();

    let MyData = useSelector((state) => state.MyData);

    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [listData, setListData] = useState([]);
    const [cancelListData, setCancelListData] = useState([]);
    const [agentlistData, setAgentListData] = useState([]);
    const [reload, setReload] = useState(false);
    const [activeTab, setActiveTab] = useState("수기결제");
    const [feeImage, setFeeImage] = useState([]);

    // ⬇️ [추가] 작은 화면에서 '안내' 모달 열기 위한 상태
    const [noticeModal, setNoticeModal] = useState(false);

    const inputRef = useRef(null);
    const pickerRef = useRef(null);

    const [preDate, setPreDate] = useState(dayjs().format("YYYY-MM-DD"));
    const [nextDate, setNextDate] = useState(dayjs().format("YYYY-MM-DD"));

    const [formData, setFormData] = useState({
        mid: "",
        GoodsName: "",
        Amt: "",
        BuyerName: "",
        BuyerEmail: "",
        BuyerHpTel: "",
        card_num: "",
        CardCvv: "",
        CardPw: "",
        ExpMonth: "",
        ExpYear: "",
        card_gubun: "개인",
        IDNo: "",
        CardQuota: "00",
    });

    // 화면 표시용
    const [displayAmt, setDisplayAmt] = useState("");
    const [cardDisplayValue, setCardDisplayValue] = useState("");
    const [phoneDisplayValue, setPhoneDisplayValue] = useState("");
    const [bank, setBank] = useState("");
    const [paymentCount, setPaymentCount] = useState({ "bol": false, "day": 0, "month": 0 });

    const [isSubmitting, setIsSubmitting] = useState(false);

    // 윈도우 크기에 따라 1280px 이상이면 Window = true
    const [Window, setWindow] = useState(true);
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1280) setWindow(true);
            else setWindow(false);
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    // ------------------------------
    // 날짜 선택
    // ------------------------------
    useEffect(() => {
        pickerRef.current = new Litepicker({
            element: inputRef.current,
            lang: "ko",
            singleMode: false,
            format: "YYYY-MM-DD",
            numberOfMonths: 2,
            numberOfColumns: 2,
            showWeekNumbers: true,
            dropdowns: {
                minYear: 2020,
                maxYear: 2030,
                months: true,
                years: true,
            },
            setup: (picker) => {
                picker.on("selected", (start, end) => {
                    setPreDate(start.format("YYYY-MM-DD"));
                    setNextDate(end.format("YYYY-MM-DD"));
                });
            },
        });
        return () => {
            pickerRef.current?.destroy();
        };
    }, []);

    useEffect(() => {
        setDateRange(dayjs().format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD"));
    }, []);

    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate);
        setNextDate(endDate);
        pickerRef.current?.setDateRange(startDate, endDate);
        onSubmitSearch();
    };

    const onSubmitSearch = () => {
        setPage(1);
        setReload((e) => !e);
    };

    useEffect(() => {
        dispatch(change_Current_Location("수기결제"));
        dispatch(
            changeHeaderTitle({
                mainTitle: "수기결제",
            })
        );
        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, [dispatch]);

    // ------------------------------
    // 휴대폰번호 3-4-4
    // ------------------------------
    const handlePhoneChange = (e) => {
        let val = e.target.value;
        let numeric = val.replace(/\D/g, "").slice(0, 11);

        let parted = [];
        if (numeric.length < 4) {
            parted = [numeric];
        } else if (numeric.length < 8) {
            parted = [numeric.slice(0, 3), numeric.slice(3)];
        } else {
            parted = [numeric.slice(0, 3), numeric.slice(3, 7), numeric.slice(7)];
        }
        let displayVal = parted.join("-");

        setPhoneDisplayValue(displayVal);
        setFormData((prev) => ({ ...prev, BuyerHpTel: numeric }));
    };

    // ------------------------------
    // 금액 입력 콤마
    // ------------------------------
    const handleAmtChange = (e) => {
        let val = e.target.value.replace(/\D/g, "").slice(0, 9);
        setFormData((prev) => ({ ...prev, Amt: val }));

        if (val === "") setDisplayAmt("");
        else setDisplayAmt(parseInt(val, 10).toLocaleString("ko-KR"));
    };

    // ------------------------------
    // 카드번호 입력 (4-4-4-4)
    // ------------------------------
    const handleCardNumberChange = (e) => {
        let numericVal = e.target.value.replace(/\D/g, "").slice(0, 16);
        const parted = numericVal.match(/.{1,4}/g) ?? [];
        const displayVal = parted.join("-");

        setCardDisplayValue(displayVal);
        setFormData((prev) => ({ ...prev, card_num: numericVal }));

        if (numericVal.length >= 8) {
            CheckBank(numericVal.slice(0, 8));
        } else {
            setBank("");
        }

        if (numericVal.length === 16) {
            CheckPaymentCount(numericVal);
        } else {
            setPaymentCount({ "bol": false, "day": 0, "month": 0 });
        }
    };

    const CheckBank = async (eightDigits) => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + "/api/card-info/check", {
                withCredentials: true,
                params: { cardNumber: eightDigits },
            });
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setBank(tmp?.data[0]?.card ?? "");
            } else if (tmp?.code === 9999) {
                navigate("/");
            } else {
                setBank("유효하지 않습니다.");
            }
        } catch (error) {
            console.error(error);
            navigate("/");
        }
    };

    // 카드 빈도수 체크 함수
    const CheckPaymentCount = async (Digits) => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + "/api/sugi/check-card", {
                withCredentials: true,
                params: { cardNum: Digits },
            });
            let tmp = response?.data;
            console.log(tmp)
            if (tmp?.code < 2000) {
                setPaymentCount({ "bol": true, "day": tmp?.data?.todayCount ?? 0, "month": tmp?.data?.monthlyCount ?? 0 });
            } else if (tmp?.code === 9999) {
                navigate("/");
            } else {
                setPaymentCount({ "bol": false, "day": 0, "month": 0 });
            }
        } catch (error) {
            console.error(error);
            navigate("/");
        }
    };

    // 일반 input
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    // ------------------------------
    // 상품명 (드롭다운/모달)
    // ------------------------------
    const [goodsDropdownOpen, setGoodsDropdownOpen] = useState(false);
    const [goodsList, setGoodsList] = useState([]);
    const [goodsInput, setGoodsInput] = useState("");
    const dropdownRef = useRef(null);
    const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 767);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        function handleClickOutside(e) {
            if (
                goodsDropdownOpen &&
                dropdownRef.current &&
                !dropdownRef.current.contains(e.target)
            ) {
                closeGoodsDropdown();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [goodsDropdownOpen]);

    const fetchGoodsList = async () => {
        try {
            let response = await axios.get(process.env.REACT_APP_API + "/api/goods", {
                withCredentials: true,
            });
            let tmp = response?.data;
            if (tmp.code < 2000) {
                setGoodsList(tmp.data ?? []);
            }
        } catch (e) {
            console.error(e);
        }
    };

    const openGoodsDropdown = async (e) => {
        await fetchGoodsList();

        if (!isMobile) {
            // PC: 드롭다운 위치 계산
            const rect = e.target.getBoundingClientRect();
            const layoutWidth = 1920; // 중앙정렬 기준 너비 (프로젝트에 따라 조정)
            const screenWidth = window.innerWidth;
            const offset = screenWidth > layoutWidth ? (screenWidth - layoutWidth) / 2 : 0;

            let newLeft = rect.left + window.scrollX - 200 - offset;
            let newTop = rect.bottom + window.scrollY - 5;
            setDropdownPos({ top: newTop, left: newLeft });
        }
        setGoodsDropdownOpen(true);
    };

    useEffect(() => {
        if (goodsDropdownOpen && !isMobile) {
            requestAnimationFrame(() => {
                if (!dropdownRef.current) return;
                const ddRect = dropdownRef.current.getBoundingClientRect();
                let { top, left } = dropdownPos;

                if (ddRect.right > window.innerWidth) {
                    const overflowX = ddRect.right - window.innerWidth + 10;
                    left -= overflowX;
                }
                if (ddRect.bottom > window.innerHeight) {
                    const overflowY = ddRect.bottom - window.innerHeight + 10;
                    top -= overflowY;
                }
                if (left < 0) left = 10;
                if (top < 0) top = 10;

                setDropdownPos({ top, left });
            });
        }
    }, [goodsDropdownOpen, dropdownPos, isMobile]);

    const closeGoodsDropdown = () => {
        setGoodsDropdownOpen(false);
        setGoodsInput("");
    };

    const addGoods = async () => {
        if (!goodsInput.trim()) {
            alert("상품명을 입력하세요.");
            return;
        }
        try {
            let res = await axios.post(
                process.env.REACT_APP_API + "/api/goods",
                { goods_name: goodsInput.trim() },
                { withCredentials: true }
            );
            if (res.data.code < 2000) {
                setGoodsInput("");
                fetchGoodsList();
            }
        } catch (e) {
            console.error(e);
        }
    };

    const deleteGoods = async (id) => {
        if (!window.confirm("상품을 삭제하시겠습니까?")) return;
        try {
            let res = await axios.post(
                process.env.REACT_APP_API + "/api/goods/delete",
                { id },
                { withCredentials: true }
            );
            if (res.data.code < 2000) {
                fetchGoodsList();
            }
        } catch (e) {
            console.error(e);
        }
    };

    const handleGoodsSelect = (name) => {
        setFormData((prev) => ({ ...prev, GoodsName: name }));
        closeGoodsDropdown();
    };

    // ------------------------------
    // 결제 요청
    // ------------------------------
    const onSubmitSugi = () => {
        MyData?.role === "SUPER" ? onSubmitSugiAdmin() : onSubmitSugiAgent();
    };

    const onSubmitSugiAdmin = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        setLoading(true);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/sugi/direct",
                {
                    mid: formData.mid,
                    payerName: formData.BuyerName,
                    payerEmail: formData.BuyerEmail,
                    payerTel: formData.BuyerHpTel,
                    cardNumber: formData.card_num,
                    cardExpiry: formData.ExpYear + formData.ExpMonth,
                    cardCvv: formData.CardCvv,
                    installment: formData.CardQuota,
                    products: [
                        {
                            prodId: "",
                            name: formData.GoodsName,
                            qty: 1,
                            price: formData.Amt,
                            desc: "수기결제",
                        },
                    ],
                    metadata: {
                        cardAuth: "true",
                        authPw: formData.CardPw,
                        authDob: formData.IDNo,
                    },
                    amount: formData.Amt,
                },
                { withCredentials: true }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                // 성공 시 초기화
                setFormData({
                    mid: "",
                    GoodsName: "",
                    Amt: "",
                    BuyerName: "",
                    BuyerEmail: "",
                    BuyerHpTel: "",
                    card_num: "",
                    CardCvv: "",
                    CardPw: "",
                    ExpMonth: "",
                    ExpYear: "",
                    card_gubun: "개인",
                    IDNo: "",
                    CardQuota: "00",
                });
                setDisplayAmt("");
                setPhoneDisplayValue("");
                setCardDisplayValue("");
                setBank("");
                setMessage({ msg: "수기결제 요청 완료" });
                setReload((e) => !e);
            } else {
                setMessage({
                    msg:
                        tmp?.data?.response?.result?.advanceMsg ||
                        tmp?.msg ||
                        "수기결제 요청 실패",
                });
            }
        } catch (error) {
            console.error(error);
            setMessage({ msg: "결제 요청 중 오류가 발생했습니다." });
        } finally {
            setLoading(false);
            setIsSubmitting(false);
        }
    };

    const onSubmitSugiAgent = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        setLoading(true);
        
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/sugi/request",
                {
                    mid: formData.mid,
                    payerName: formData.BuyerName,
                    payerEmail: formData.BuyerEmail,
                    payerTel: formData.BuyerHpTel,
                    cardNumber: formData.card_num,
                    cardExpiry: formData.ExpYear + formData.ExpMonth,
                    cardCvv: formData.CardCvv,
                    installment: formData.CardQuota,
                    products: [
                        {
                            prodId: "",
                            name: formData.GoodsName || "상품명미지정",
                            qty: 1,
                            price: formData.Amt,
                            desc: "수기결제",
                        },
                    ],
                    metadata: {
                        cardAuth: "true",
                        authPw: formData.CardPw,
                        authDob: formData.IDNo,
                    },
                    amount: formData.Amt,
                },
                { withCredentials: true }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setFormData({
                    mid: "",
                    GoodsName: "",
                    Amt: "",
                    BuyerName: "",
                    BuyerEmail: "",
                    BuyerHpTel: "",
                    card_num: "",
                    CardCvv: "",
                    CardPw: "",
                    ExpMonth: "",
                    ExpYear: "",
                    card_gubun: "개인",
                    IDNo: "",
                    CardQuota: "00",
                });
                setDisplayAmt("");
                setPhoneDisplayValue("");
                setCardDisplayValue("");
                setBank("");
                setMessage({ msg: "수기결제 요청 완료" });
                setReload((e) => !e);
            } else {
                setMessage({
                    msg:
                        tmp?.data?.response?.result?.advanceMsg ||
                        tmp?.msg ||
                        "수기결제 요청 실패",
                });
            }
        } catch (error) {
            console.error(error);
            setMessage({ msg: "결제 요청 중 오류가 발생했습니다." });
        } finally {
            setLoading(false);
            setIsSubmitting(false);
        }
    };

    // ------------------------------
    // 수기결제 목록, 취소 목록, 가맹점 목록, 수수료 안내
    // ------------------------------
    useEffect(() => {
        ListData();
        CancelListData();
        CheckFee();
    }, [reload]);

    useEffect(() => {
        AgentListData();
    }, []);

    const ListData = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + "/api/sugi", {
                withCredentials: true,
            });
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setListData(tmp?.data ?? []);
            } else if (tmp?.code === 9999) {
                navigate("/");
            }
        } catch (error) {
            console.error(error);
            navigate("/");
        }
    };

    const CancelListData = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + "/api/sugi/cancel/list", {
                withCredentials: true,
            });
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setCancelListData(tmp?.data ?? []);
            } else if (tmp?.code === 9999) {
                navigate("/");
            }
        } catch (error) {
            console.error(error);
            navigate("/");
        }
    };

    const AgentListData = async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + "/api/sugi/merchant/list",
                { withCredentials: true }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setAgentListData(tmp?.data ?? []);
            } else if (tmp?.code === 9999) {
                navigate("/");
            }
        } catch (error) {
            console.error(error);
            navigate("/");
        }
    };

    const CheckFee = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + "/api/card-fee/fee-info", {
                withCredentials: true,
            });
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setFeeImage(tmp?.data?.feeInfo);
            } else if (tmp?.code === 9999) {
                navigate("/");
            }
        } catch (error) {
            console.error(error);
            navigate("/");
        }
    };

    // ------------------------------
    // 탭
    // ------------------------------
    const handleClickTab = (tabName) => {
        setActiveTab(tabName);
    };
    const tabList = ["수기결제"];

    // ------------------------------
    // 할부기간 (일시불~10개월 → 필요에 따라 최대 24개월 등 확장)
    // ------------------------------
    const quotaOptions = Array.from({ length: 11 }, (_, i) => {
        if (i === 0) {
            return { value: "00", label: "일시불" };
        } else {
            const padded = String(i).padStart(2, "0");
            return { value: padded, label: `${padded}개월` };
        }
    });

    // ------------------------------
    // 인라인 스타일(placeholder 글씨 크기)
    // ------------------------------
    const styleOverride = `
      .big-input {
        font-size: 16px !important;
      }
      .big-input::placeholder {
        font-size: 16px !important;
      }
    `;

    return (
        <div className="content" id="contents" style={{ position: "relative" }}>
            <style>{styleOverride}</style>
            {loading ? <LoadingModal /> : null}
            <MessageModal message={message} />

            {/* ⬇️ [추가] 작은 화면에서 '안내' 버튼 누르면 모달 */}
            {noticeModal && !Window && (
                <NoticeModal feeImage={feeImage} setNoticeModal={setNoticeModal} />
            )}

            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDate
                        type={"기간"}
                        inputRef={inputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                        isDisabled={true}
                    />
                </form>
            </div>

            <div
                className="intro-y box intro-padding"
                style={{
                    marginTop: "0.5rem",
                    padding: "1rem",
                    paddingBottom: "0",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                        justifyContent: "space-between",
                        borderBottom: "1px solid #E5E5E5",
                        backgroundColor: "#fff",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        {tabList.map((tab) => (
                            <button
                                key={tab}
                                className={`tab-btn ${activeTab === tab ? "active" : ""}`}
                                onClick={() => handleClickTab(tab)}
                                style={{
                                    padding: "12px 10px 8px",
                                    fontSize: "14px",
                                    fontWeight: activeTab === tab ? "600" : "400",
                                    color: activeTab === tab ? "#222" : "#888",
                                    background: "transparent",
                                    border: "none",
                                    borderBottom:
                                        activeTab === tab
                                            ? "3px solid #3182F6"
                                            : "3px solid transparent",
                                    transition: "all 0.2s ease-in-out",
                                    cursor: "pointer",
                                }}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                </div>

                <div
                    className="div-flex-2 contents"
                    style={{ gap: "20px", height: "calc(100dvh - 14rem)", minHeight: "650px" }}
                >
                    {/* ------------------------------ */}
                    {/* 왼쪽: 수기결제 요청 폼           */}
                    {/* ------------------------------ */}
                    <div
                        className="content-wrap"
                        style={{ maxWidth: "400px", width: "100%" }}
                    >
                        <form
                            className="content-item payForm active"
                            name="payForm"
                            id="payForm"
                            method="post"
                            acceptCharset="UTF-8"
                            autoComplete="off"
                            noValidate
                        >
                            <div
                                className="intro-yy box"
                                style={{
                                    minHeight: "620px",
                                }}
                            >
                                <input type="password" style={{ display: "none" }} readOnly />

                                {/* 첫 줄: 가맹점 + (SUPER 아니라면 금액), SUPER면 나중에 별도 표기 */}
                                <div style={{ display: "flex", gap: "0.5rem", width: "100%" }}>
                                    <div className="input">
                                        <label htmlFor="mid" className="form-label">
                                            가맹점선택
                                        </label>
                                        <select
                                            id="mid"
                                            name="mid"
                                            className="form-select mt-2 sm:mr-2"
                                            value={formData.mid}
                                            onChange={handleChange}
                                            style={{
                                                width: "100%",
                                                paddingTop: ".5rem",
                                                paddingBottom: ".5rem",
                                                fontSize: "16px",
                                            }}
                                        >
                                            <option value="">선택</option>
                                            {agentlistData.map((a, i) => (
                                                <option key={i} value={a.mid}>
                                                    {a.co_nm}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    {MyData?.role !== "SUPER" && (
                                        <div className="input">
                                            <label htmlFor="Amt" className="form-label">
                                                금액
                                            </label>
                                            <input
                                                id="Amt"
                                                name="Amt"
                                                type="text"
                                                className="form-control big-input"
                                                placeholder="금액 입력"
                                                maxLength={12}
                                                value={displayAmt}
                                                onChange={handleAmtChange}
                                            />
                                        </div>
                                    )}
                                </div>

                                {/* 카드번호 */}
                                <div className="input_w_70 input">
                                    <label
                                        htmlFor="card_num"
                                        className="form-label"
                                        style={{ width: "100%" }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                width: "100%",
                                            }}
                                        >
                                            <div style={{ display: "flex", gap: "5px" }}>
                                                <div>
                                                    신용카드번호
                                                </div>
                                                {
                                                    paymentCount.bol
                                                        ?
                                                        <div
                                                            style={{
                                                                color: "red",
                                                                fontSize: "12px",
                                                            }}
                                                        >
                                                            ({paymentCount.day}회/일, {paymentCount.month}회/월)
                                                        </div>
                                                        :
                                                        ""
                                                }
                                            </div>
                                            <div
                                                style={{
                                                    color: "red",
                                                    fontSize: "12px",
                                                    height: "20px",
                                                }}
                                            >
                                                {bank.length > 0 ? `* ${bank}` : ""}
                                            </div>
                                        </div>
                                    </label>
                                    <input
                                        id="card_num"
                                        name="card_num"
                                        type="text"
                                        className="form-control big-input"
                                        placeholder="xxxx-xxxx-xxxx-xxxx"
                                        value={cardDisplayValue}
                                        onChange={handleCardNumberChange}
                                    />
                                </div>

                                {/* 카드비밀번호 + 유효기간 */}
                                <div style={{ display: "flex", gap: "0.5rem", width: "100%" }}>
                                    <div
                                        className="input_w_30 input"
                                        style={{ width: "33%" }}
                                    >
                                        <label htmlFor="CardPw" className="form-label">
                                            카드비밀번호
                                        </label>
                                        <input
                                            id="CardPw"
                                            name="CardPw"
                                            type="password"
                                            pattern="[0-9]*"
                                            inputMode="numeric"
                                            className="form-control big-input"
                                            maxLength={2}
                                            placeholder="앞2자리"
                                            autoComplete="new-password"
                                            value={formData.CardPw}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div
                                        className="input_w_55 input"
                                        style={{ width: "67%" }}
                                    >
                                        <label htmlFor="ExpMonth" className="form-label">
                                            카드 유효기간 (월/년)
                                        </label>
                                        <div className="multiple">
                                            <input
                                                id="ExpMonth"
                                                name="ExpMonth"
                                                type="text"
                                                pattern="[0-9]*"
                                                inputMode="numeric"
                                                className="form-control big-input"
                                                maxLength={2}
                                                placeholder="월"
                                                value={formData.ExpMonth}
                                                onChange={handleChange}
                                            />
                                            <span>/</span>
                                            <input
                                                id="ExpYear"
                                                name="ExpYear"
                                                type="text"
                                                pattern="[0-9]*"
                                                inputMode="numeric"
                                                className="form-control big-input"
                                                maxLength={4}
                                                placeholder="년"
                                                value={formData.ExpYear}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* 상품명 + (SUPER일 때 금액) */}
                                <div style={{ display: "flex", gap: "0.5rem", width: "100%" }}>
                                    <div className="input">
                                        <label className="form-label" style={{ display: "block" }}>
                                            상품명
                                        </label>
                                        <div
                                            style={{
                                                minHeight: "38px",
                                                border: "1px solid #e2e8f0",
                                                borderRadius: "0.375rem",
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "8px",
                                                cursor: "pointer",
                                                fontSize: "16px",
                                                boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                                                color: formData.GoodsName ? "#333" : "#999",
                                                textDecoration: "underline",
                                            }}
                                            onClick={(e) => openGoodsDropdown(e)}
                                        >
                                            {formData.GoodsName
                                                ? formData.GoodsName
                                                : "상품선택 (클릭)"}
                                        </div>
                                    </div>
                                    {MyData?.role === "SUPER" && (
                                        <div className="input">
                                            <label htmlFor="Amt" className="form-label">
                                                금액
                                            </label>
                                            <input
                                                id="Amt"
                                                name="Amt"
                                                type="text"
                                                className="form-control big-input"
                                                placeholder="금액 입력"
                                                maxLength={12}
                                                value={displayAmt}
                                                onChange={handleAmtChange}
                                            />
                                        </div>
                                    )}
                                </div>

                                {/* 구매자명 / 휴대폰번호 */}
                                <div style={{ display: "flex", gap: "0.5rem", width: "100%" }}>
                                    <div className="input">
                                        <label htmlFor="BuyerName" className="form-label">
                                            구매자명
                                        </label>
                                        <input
                                            id="BuyerName"
                                            name="BuyerName"
                                            type="text"
                                            className="form-control big-input"
                                            placeholder="이름 입력"
                                            maxLength={20}
                                            value={formData.BuyerName}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="input">
                                        <label htmlFor="BuyerHpTel" className="form-label">
                                            휴대폰번호
                                        </label>
                                        <input
                                            id="BuyerHpTel"
                                            name="BuyerHpTel"
                                            type="text"
                                            className="form-control big-input"
                                            placeholder="010-1234-5678"
                                            value={phoneDisplayValue}
                                            onChange={handlePhoneChange}
                                        />
                                    </div>
                                </div>

                                {/* 생년월일 + 할부기간 */}
                                <div style={{ display: "flex", gap: "0.5rem", width: "100%" }}>
                                    <div className="input_w_50 input" style={{ width: "60%" }}>
                                        <label htmlFor="IDNo" className="form-label">
                                            생년월일/사업자번호
                                        </label>
                                        <input
                                            id="IDNo"
                                            name="IDNo"
                                            type="text"
                                            pattern="[0-9]*"
                                            inputMode="numeric"
                                            className="form-control big-input"
                                            maxLength={13}
                                            placeholder="생년월일/사업자번호"
                                            value={formData.IDNo}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div
                                        className="input_w_50 input"
                                        style={{ width: "40%" }}
                                    >
                                        <label
                                            htmlFor="CardQuota"
                                            className="form-label"
                                            style={{ width: "100%" }}
                                        >
                                            {/* label 내부에 small-screen 안내 버튼 */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    width: "100%",
                                                }}
                                            >
                                                <div>할부기간</div>
                                                {!Window && feeImage?.imageUrl && (
                                                    <button
                                                        type="button"
                                                        onClick={() => setNoticeModal((prev) => !prev)}
                                                        style={{
                                                            padding: "0px 5px",
                                                            fontSize: "11px",
                                                            fontWeight: "bold",
                                                            backgroundColor: "#f7f789",
                                                            border: "1px solid #ccc",
                                                            borderRadius: "4px",
                                                            cursor: "pointer",
                                                            height: "20px",
                                                        }}
                                                    >
                                                        안내
                                                    </button>
                                                )}
                                            </div>
                                        </label>
                                        <select
                                            id="CardQuota"
                                            name="CardQuota"
                                            className="form-select big-input mt-2 sm:mr-2"
                                            value={formData.CardQuota}
                                            onChange={handleChange}
                                            style={{
                                                width: "100%",
                                                paddingTop: ".5rem",
                                                paddingBottom: ".5rem",
                                            }}
                                        >
                                            {quotaOptions.map((item) => (
                                                <option key={item.value} value={item.value}>
                                                    {item.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="payBt">
                                    <input
                                        id="ec_pay_btn"
                                        className="btn btn-primary mt-3 big-input"
                                        style={{ fontSize: "16px" }}
                                        type="button"
                                        value={
                                            isSubmitting
                                                ? MyData?.role === "SUPER"
                                                    ? "결제중..."
                                                    : "요청중..."
                                                : MyData?.role === "SUPER"
                                                    ? "결제"
                                                    : "요청"
                                        }
                                        onClick={onSubmitSugi}
                                        disabled={isSubmitting}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>

                    {/* ------------------------------ */}
                    {/* 오른쪽(PC): 수수료 안내 이미지 */}
                    {/* 작은 화면에서는 모달 버튼만 노출 */}
                    {/* ------------------------------ */}
                    {Window && feeImage?.imageUrl && (
                        <div
                            style={{
                                background: "#fff",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "20px",
                                height: "90%",
                            }}
                        >
                            <img
                                src={feeImage?.imageUrl ?? ""}
                                style={{ objectFit: "contain", height: "100%" }}
                                alt="수수료안내"
                            />
                        </div>
                    )}
                </div>
            </div>

            {/* ------------------------------ */}
            {/* 상품 선택 (드롭다운/모바일 모달) */}
            {/* ------------------------------ */}
            {goodsDropdownOpen &&
                (isMobile ? (
                    /* ==========================
                       모바일: 풀스크린 모달
                       ========================== */
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "rgba(0,0,0,0.5)",
                            zIndex: 9999,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        onClick={closeGoodsDropdown}
                    >
                        <div
                            ref={dropdownRef}
                            style={{
                                width: "90%",
                                maxWidth: "400px",
                                backgroundColor: "#fff",
                                borderRadius: "8px",
                                padding: "20px",
                                position: "relative",
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                }}
                            >
                                <h2 style={{ fontSize: "18px", margin: 0 }}>상품 선택</h2>
                                <div
                                    style={{
                                        cursor: "pointer",
                                        color: "#999",
                                    }}
                                    onClick={closeGoodsDropdown}
                                >
                                    <X size={22} />
                                </div>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    gap: "10px",
                                    marginBottom: "10px",
                                    height: "35px",
                                    fontSize: "13px",
                                }}
                            >
                                <input
                                    type="text"
                                    className="custom-input"
                                    placeholder="상품명 입력"
                                    value={goodsInput}
                                    onChange={(e) => setGoodsInput(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") addGoods();
                                    }}
                                    style={{
                                        flex: 1,
                                        border: "1px solid #ccc",
                                        padding: "0px 10px",
                                        borderRadius: "4px",
                                        fontSize: "16px",
                                    }}
                                />
                                <button
                                    onClick={addGoods}
                                    style={{
                                        backgroundColor: "#3182F6",
                                        color: "#fff",
                                        padding: "0px 10px",
                                        border: "none",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                    }}
                                >
                                    등록
                                </button>
                            </div>

                            <div
                                style={{
                                    maxHeight: "300px",
                                    overflowY: "auto",
                                }}
                            >
                                {(() => {
                                    const chunkedGoodsList = [];
                                    for (let i = 0; i < goodsList.length; i += 2) {
                                        chunkedGoodsList.push(goodsList.slice(i, i + 2));
                                    }
                                    if (chunkedGoodsList.length === 0) {
                                        return (
                                            <div
                                                style={{
                                                    textAlign: "center",
                                                    margin: "10px 0",
                                                    color: "#666",
                                                }}
                                            >
                                                등록된 상품이 없습니다.
                                            </div>
                                        );
                                    }
                                    return chunkedGoodsList.map((rowItems, rowIndex) => (
                                        <div
                                            key={rowIndex}
                                            style={{
                                                display: "flex",
                                                borderBottom: "1px solid #eee",
                                                padding: "6px 0",
                                                gap: "10px",
                                            }}
                                        >
                                            {rowItems.map((item) => (
                                                <div
                                                    key={item.id}
                                                    style={{
                                                        flex: 1,
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            cursor: "pointer",
                                                            width: "calc(100% - 20px)",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                            fontSize: "15px",
                                                        }}
                                                        onClick={() =>
                                                            handleGoodsSelect(item.goods_name)
                                                        }
                                                    >
                                                        {item.goods_name}
                                                    </div>
                                                    <div
                                                        onClick={() => deleteGoods(item.id)}
                                                        style={{
                                                            cursor: "pointer",
                                                            color: "#b91c1c",
                                                            marginLeft: "10px",
                                                            flexShrink: 0,
                                                        }}
                                                    >
                                                        <X size={18} />
                                                    </div>
                                                </div>
                                            ))}
                                            {rowItems.length === 1 && <div style={{ flex: 1 }} />}
                                        </div>
                                    ));
                                })()}
                            </div>
                        </div>
                    </div>
                ) : (
                    /* ==========================
                       PC: 드롭다운
                       ========================== */
                    <div
                        ref={dropdownRef}
                        style={{
                            position: "absolute",
                            top: dropdownPos.top,
                            left: dropdownPos.left + 8,
                            width: "355px",
                            backgroundColor: "#fff",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            padding: "10px",
                            zIndex: 9999,
                            boxShadow: "rgba(0, 0, 0, 0.04) 0px 0.25rem 0.5rem",
                            border: "2px solid #dfdfdf",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "10px",
                            }}
                        >
                            <h2 style={{ fontSize: "16px" }}>상품 선택</h2>
                            <div
                                style={{
                                    cursor: "pointer",
                                    fontSize: "18px",
                                    color: "#999",
                                    marginLeft: "10px",
                                }}
                                onClick={closeGoodsDropdown}
                            >
                                <X size={20} />
                            </div>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                gap: "10px",
                                marginBottom: "10px",
                                height: "30px",
                                fontSize: "13px",
                            }}
                        >
                            <input
                                type="text"
                                placeholder="상품명 입력"
                                value={goodsInput}
                                onChange={(e) => setGoodsInput(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") addGoods();
                                }}
                                style={{
                                    flex: 1,
                                    border: "1px solid #ccc",
                                    padding: "0px 10px",
                                    borderRadius: "4px",
                                    fontSize: "13px",
                                }}
                            />
                            <button
                                onClick={addGoods}
                                style={{
                                    backgroundColor: "#3182F6",
                                    color: "#fff",
                                    padding: "0px 10px",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                }}
                            >
                                등록
                            </button>
                        </div>
                        <div
                            style={{
                                maxHeight: "200px",
                                overflowY: "auto",
                            }}
                        >
                            {(() => {
                                const chunkedGoodsList = [];
                                for (let i = 0; i < goodsList.length; i += 2) {
                                    chunkedGoodsList.push(goodsList.slice(i, i + 2));
                                }
                                if (chunkedGoodsList.length === 0) {
                                    return (
                                        <div
                                            style={{
                                                textAlign: "center",
                                                margin: "10px 0",
                                                color: "#666",
                                            }}
                                        >
                                            등록된 상품이 없습니다.
                                        </div>
                                    );
                                }
                                return chunkedGoodsList.map((rowItems, rowIndex) => (
                                    <div
                                        key={rowIndex}
                                        style={{
                                            display: "flex",
                                            borderBottom: "1px solid #eee",
                                            padding: "5px 0",
                                            gap: "10px",
                                        }}
                                    >
                                        {rowItems.map((item) => (
                                            <div
                                                key={item.id}
                                                style={{
                                                    flex: 1,
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        cursor: "pointer",
                                                        width: "calc(100% - 20px)",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        fontSize: "13px",
                                                    }}
                                                    onClick={() =>
                                                        handleGoodsSelect(item.goods_name)
                                                    }
                                                >
                                                    {item.goods_name}
                                                </div>
                                                <div
                                                    onClick={() => deleteGoods(item.id)}
                                                    style={{
                                                        cursor: "pointer",
                                                        color: "#b91c1c",
                                                        marginLeft: "10px",
                                                        flexShrink: 0,
                                                    }}
                                                >
                                                    <X size={16} />
                                                </div>
                                            </div>
                                        ))}
                                        {rowItems.length === 1 && <div style={{ flex: 1 }} />}
                                    </div>
                                ));
                            })()}
                        </div>
                    </div>
                ))}
        </div>
    );
}

function NoticeModal({ feeImage, setNoticeModal }) {
    return (
        <div
            style={{
                background: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "90px 20px 20px",
                width: "100%",
                height: "100%",
                position: "fixed",
                top: "0",
                left: "0",
                zIndex: "50",
            }}
        >
            <div
                style={{ position: "absolute", top: "75px", right: "10px", cursor: "pointer" }}
                onClick={() => setNoticeModal(false)}
            >
                <X size={30} />
            </div>
            <img
                src={feeImage?.imageUrl ?? ""}
                style={{ objectFit: "contain", height: "100%" }}
                alt="수수료안내"
            />
        </div>
    );
}

export default SugiManage